import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { VoucherTypesLayout } from '@/features/voucher-types/components/voucher-types-layout'

const voucherTypesSearchSchema = z.object({
  isRedeemable: z
    .union([z.boolean(), z.string()])
    .optional()
    .transform((val) => {
      if (val === undefined) return undefined
      if (typeof val === 'boolean') return val
      return val === 'true'
    }),
})

export type VoucherTypesSearch = z.infer<typeof voucherTypesSearchSchema>

export const Route = createFileRoute('/_authenticated/voucher-types')({
  component: VoucherTypesLayout,
  validateSearch: voucherTypesSearchSchema,
})
